const DynamicTemplateModel = {
    id: "",
    name: "",
    description: "",
    programming: "",
    assets: [],
    travel_time: 5,
    action: "",
    filters: {
        download_type: "",
        waste_type: "",
        groups: [],
        islands: [],
        routes: [],
        zones: [],
        uuids: [],
    },
    params: {
        period: 0,
        origin: "",
        destination: "",
        unload: "",
        unload_type: "",
        unload_time: 0,
        refueling: "",
        refueling_time: 0,
        refueling_place: "s",
        duration: "",
        filling: 90,
        days: 5,
        force: false,
        // - Criterios del punto 5 por defecto
        c1: true,
        c2: true,
        c3: true,
        // - C4/C5/C6: horas sin comunicar (solo de plantilla)
        c4: true,
        c4_hours: 6,
        c5: true,
        c5_hours: 16,
        c6: true,
        c6_hours: 24,
    },
    priorities: {
        action: "",
        reduce: false,
        expand: false,
        reduce_first: "n",
        reduce_second: "n",
        expand_first: "n",
        ajust_time: false,
        // - Punto 5 (C1/C2/C3)
        risk_threshold: 80,
        target_threshold: 70,
        tomorrow_threshold: 80, // C3
        c4_threshold: 80,
        c5_threshold: 60,
        c6_threshold: 40,
        window_start: "07:00",
        forecast_days: 2,
    },
};
export default DynamicTemplateModel;
